module.exports = __webpack_public_path__ + "media/images/coupon-is-here-c3507e9ba164282510fe774f1dc81e9f.svg";